import { SearchIconOutline } from '@com/icons';
import SpeechToTextButton from '@com/shared/speechToTextButton';
import { generalTexts } from '@com/texts/generalTexts';
import { useEffect, useRef } from 'react';

interface Props {
  title?: string | (() => string) | null;
  className?: string;
  value: string;
  onChange: (value: string) => void;
  onEnter?: (value: string) => void;
  autoFocus?: boolean;
  isActiveEnterButton?: boolean;
  withSpeechToText?: boolean;
}

const SearchBox = ({
  title,
  className = '',
  value,
  onChange,
  onEnter,
  autoFocus = false,
  isActiveEnterButton = true,
  withSpeechToText = true,
}: Props) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const resolvedTitle = typeof title === 'function' ? title() : title;
  // Auto focus input if enabled
  useEffect(() => {
    if (autoFocus && inputRef.current) {
      inputRef.current.focus();
    }
  }, [autoFocus]);

  const handleKeyUp = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && isActiveEnterButton) {
      onEnter?.(e.currentTarget.value);
    }
  };

  return (
    <div className={`w-full relative h-[48px] ${className}`}>
      <SearchIconOutline
        className="absolute right-4 top-1/2 -translate-y-1/2"
        height={24}
        width={24}
        fill={'#535454'}
      />
      {withSpeechToText && (
        <SpeechToTextButton
          onChange={(newChunk) => {
            onChange(value ? value + ' ' + newChunk : newChunk);
          }}
          className="absolute left-2 top-1/2 -translate-y-1/2"
        />
      )}
      <input
        ref={inputRef}
        value={value}
        onKeyUp={handleKeyUp}
        onChange={(e) => onChange(e.target.value)}
        className={`h-[48px] pr-12 bg-grey-100 text-grey-500 placeholder:text-grey-500 font-bold w-full py-3.5 rounded-full text-sm ${withSpeechToText ? 'pl-3' : 'pl-4'}`}
        placeholder={`${resolvedTitle ?? generalTexts?.drugSearch}`}
      />
    </div>
  );
};

export default SearchBox;
